import React from "react";
import {
  PRODUCT_TYPES_ENUMS,
  SET_BY_MARGIN_ENUMS,
} from "../../../system/globalEnums";
import SelectField from "../selectField/SelectField";
import { Col } from "react-bootstrap";
import { handleCategorySelect, handleMenuProductClick } from "../../utility";
import SearchInventory from "../../../views/Inventory/Items/SearchInventory/SearchInventory";

const ItemOrganizationSearch = ({
  values,
  searchCategories,
  setByFilter,
  setSearchCategories,
  selectedCategories,
  setSelectedCategories,
  filterProductCategory,
  asyncSelectRef,
  customTypes,
  customCategories,
}) => {
  return (
    <>
      {values.setBy !== SET_BY_MARGIN_ENUMS.PRODUCT.value ? (
        <Col md={12} className="p-0 position-relative">
          <SelectField
            name="searchOptions"
            options={searchCategories.map((category) => ({
              value: category,
              label: category?.name,
            }))}
            isSearchable={true}
            isSelectedValueAsPlaceholder={false}
            placeHolder={
              values.setBy === SET_BY_MARGIN_ENUMS.TYPE.value
                ? "Search Types"
                : values.setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value
                ? "Search Categories"
                : values.setBy === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
                ? "Search Sub-Categories"
                : "Search Item"
            }
            onChangeValue={(option) => {
              handleCategorySelect(
                option,
                setByFilter,
                searchCategories,
                setSearchCategories,
                selectedCategories,
                setSelectedCategories,
                filterProductCategory
              );
            }}
          />
        </Col>
      ) : (
        <Col md={12} className="p-0">
          <SearchInventory
            asyncSelectRef={asyncSelectRef}
            isTradeInSearch={true}
            handleMenuProductClick={(value) => {
              handleMenuProductClick(
                value,
                selectedCategories,
                setSelectedCategories
              );
            }}
            dropdownIndicator={false}
            placeHolder="Add Product By Search"
            defaultProductType={PRODUCT_TYPES_ENUMS.VIDEO_GAME}
            customTypes={customTypes}
            customCategories={customCategories}
            isTypeDisabled={true}
          />
        </Col>
      )}
    </>
  );
};

export default ItemOrganizationSearch;
